import React from 'react';
import { TaskItemsDeserialize } from './utils';
import { BuilderContext } from './task-list/task-items/task-item-fields/types';
import { TaskListItem } from './task-list/TaskListItem';

export const TaskListItemContext = React.createContext({
  setFieldValue: (_unusedfield: string, _unusedvalue: any, _unusedshouldValidate?: boolean | undefined) => {},
  draggingId: '',
  setDraggingId: (_unusednewDraggingId: string) => {},
  taskItems: {
    allIds: [] as Array<string>,
    byId: {},
    byTrigger: {},
    byTriggerOption: {},
  } as TaskItemsDeserialize,
});

interface TaskListItemContextProviderProps {
  children: React.ReactElement;
  taskItems: TaskItemsDeserialize;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
}

export const TaskListItemContextProvider = ({
  children,
  taskItems,
  setFieldValue,
}: TaskListItemContextProviderProps) => {
  const [draggingId, setDraggingId] = React.useState('');

  const builderContextValue = React.useMemo(
    () => ({
      items: taskItems,
      draggingId,
      renderItem: (itemId: string, index: number) => <TaskListItem taskItemId={itemId} index={index} />,
      itemLabel: 'task fields',
    }),
    [taskItems, draggingId]
  );

  return (
    <TaskListItemContext.Provider
      value={{
        draggingId,
        setDraggingId,
        taskItems,
        setFieldValue,
      }}
    >
      <BuilderContext.Provider value={builderContextValue}>{children}</BuilderContext.Provider>
    </TaskListItemContext.Provider>
  );
};
